import { Component, Input } from "@angular/core";
import { AuthenticationService } from "src/app/services/auth/Authentication/authentication.service";
import { SettingsService } from "src/app/services/settings.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  @Input() showHeader: boolean = false;

  public menu = [
    {
      name: "Редакция на технологии",
      link: "editrecipes",
    },
    {
      name: "Производство полуфабрикати",
      link: "subproducts",
    },
    {
      name: "Продуктова структура",
      link: "productstructure",
    },
    {
      name: "Продажби",
      link: "sales",
    },
    {
      name: "Смяна на статус",
      link: "changestatus",
    },
    // {
    //   name: 'Приключване ПН',
    //   link: 'complete'
    // },
  ];

  constructor(
    private auth: AuthenticationService,
    private settings: SettingsService,
    ) { }

  ngOnInit() {
    if(this.settings.tenant.name === 'Ilinden Ltd') {
      this.menu.push(    {
        name: "Справка производство",
        link: "analysis-po",
      });
    }
  }
 
  logout() {
    this.auth.logout();
  }
}
